<template>
  <div>
    <div class="level">
      <div class="level-left">
        <div class="level-item">
          <h1 class="is-size-6 has-text-weight-semibold">{{label}}</h1>
          <b-tooltip :label="tooltip" v-if="tooltip" :multilined="true" :animated="true" type="is-warning">
            <span class="icon has-text-info">
              <i class="fas fa-info-circle"></i>
            </span>
          </b-tooltip>
        </div>
      </div>
    </div>
    <b-field
            :type="errors.has(name) ? 'is-danger' : ''"
            :message="errors.has(name) ? errors.first(name) : ''">
      <b-input :disabled="disabled" :name="name" v-model="displayData" v-validate="validationRule" v-on:input="update" :icon-pack="iconPack" :icon="icon"></b-input>
    </b-field>
  </div>
</template>

<script>
export default {
  props: ['name', 'value', 'label', 'validation-rule', 'icon-pack', 'icon', 'disabled', 'tooltip'],
  inject: ['$validator'],
  data() {
    return {
      displayData: this.value
    }
  },
  methods: {
    update: function() {
      this.$emit('input', this.displayData)
    }
  }
}
</script>

<style lang="scss" scoped>
.level {
  margin-bottom: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/modules/inputs/RvText.vue